import axios from '@/lib/axios';
import { FixedAsset, Product } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 2020. 固定資産編集
 * [POST] /workspaces/:identifier/fixed_assets/:id
 */
type Props = {
  identifier: string;
  id: number;
  name: string;
  description: string;
  quantity: number;
  start_date: string;
  image_file: string;
  fixed_asset_status_id: number;
};
const updateFixedAsset = (props: Props): Promise<FixedAsset> => {
  return axios.put(`/api/workspaces/${props.identifier}/fixed_assets/${props.id}`, props);
};

export const useUpdateFixedAsset = () => {
  return useMutation({
    mutationFn: updateFixedAsset,
  });
};
